import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', path: '/' },
  { label: '网红黑料', path: '/category/wanghong' },
  { label: '明星八卦', path: '/category/mingxing' },
  { label: '热门吃瓜', path: '/category/remen' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setSearchOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70' : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-7xl mx-auto">
          <div className="hidden md:flex items-center gap-8">
            {navItems.slice(0, 3).map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm whitespace-nowrap transition-colors duration-200 ${
                  location.pathname === item.path
                    ? 'text-primary-600 font-medium'
                    : scrolled
                      ? 'text-foreground-700 hover:text-foreground-950'
                      : 'text-white/90 hover:text-white'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
              <span className="text-white text-sm font-bold">🍉</span>
            </div>
            <span
              className={`text-lg font-bold whitespace-nowrap ${scrolled ? 'text-foreground-950' : 'text-white'}`}
            >
              吃瓜视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            {navItems.slice(3).map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm whitespace-nowrap transition-colors duration-200 ${
                  location.pathname === item.path
                    ? 'text-primary-600 font-medium'
                    : scrolled
                      ? 'text-foreground-700 hover:text-foreground-950'
                      : 'text-white/90 hover:text-white'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <button
              onClick={() => setSearchOpen(!searchOpen)}
              className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer ${
                scrolled ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200' : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-full cursor-pointer ${
              scrolled ? 'text-foreground-700' : 'text-white'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {searchOpen && (
          <div className="absolute top-16 left-0 right-0 bg-background-50 border-b border-background-200/70 px-4 py-3">
            <div className="max-w-2xl mx-auto flex items-center gap-3">
              <i className="ri-search-line text-foreground-400 text-lg"></i>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索吃瓜内容..."
                className="flex-1 bg-transparent text-sm text-foreground-900 placeholder-foreground-400 outline-none"
              />
              <button
                onClick={() => setSearchOpen(false)}
                className="text-foreground-400 hover:text-foreground-600 cursor-pointer"
              >
                <i className="ri-close-line text-lg"></i>
              </button>
            </div>
          </div>
        )}

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-b border-background-200/70">
            <div className="flex flex-col py-3 px-4 gap-2">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`py-2 px-3 rounded-lg text-sm transition-colors ${
                    location.pathname === item.path
                      ? 'bg-primary-50 text-primary-600 font-medium'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}